"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var logger = function logger(store) {
  return function (next) {
    return function (action) {
      console.group(action.type);
      console.log('the action: ', action);
      var returnValue = next(action);
      console.log('the new state: ', store.getState());
      console.groupEnd();
      return returnValue;
    };
  };
};

exports.default = logger;